import VersionResult from "api/lib/data/interfaces/VersionResult";
import Query from "api/lib/data/Query";
import * as React from "react";
import moment from "moment";
import ReactDiffViewer from "react-diff-viewer";
import { Button, Label, Menu, Modal, Tab } from "semantic-ui-react";
import sqlFormatter from "sql-formatter";
import { Base, Event, IBaseProps, IBaseState } from "../Common/Base";

const timeFromNow = (timestamp: object) => moment(timestamp).fromNow();

export interface IVersionHistoryModalProps extends IBaseProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  query: Query;
}

export interface IVersionHistoryModalState extends IBaseState {
  panes: any[];
}

enum DiffMethod {
  CHARS = "diffChars",
  WORDS = "diffWords",
  WORDS_WITH_SPACE = "diffWordsWithSpace",
  LINES = "diffLines",
  TRIMMED_LINES = "diffTrimmedLines",
  SENTENCES = "diffSentences",
  CSS = "diffCss",
}

export default class VersionHistoryModal extends Base<
  IVersionHistoryModalProps,
  IVersionHistoryModalState
> {
  static INITIAL_STATE = {
    ...Base.BASE_INITAL_STATE,
    panes: [],
  };
  constructor(props: IVersionHistoryModalProps) {
    super(props);

    this.state = { ...VersionHistoryModal.INITIAL_STATE };
  }

  public componentDidMount = () => {
    this.getData();
  };

  public render() {
    const { open, setOpen } = this.props;
    return (
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        size="large"
      >
        <Modal.Header>Version History</Modal.Header>
        <Modal.Content scrolling={true}>
          <Tab
            className="version-history-tabs"
            menu={{ vertical: true, fluid: true }}
            menuPosition="left"
            panes={this.state.panes}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </Modal.Actions>
      </Modal>
    );
  }

  private getData = () => {
    const { query } = this.props;
    this.getOnceListner(
      query.getVersions(),
      Event.Value,
      (snapshot: firebase.database.DataSnapshot) => {
        const dataObj: VersionResult = snapshot.val();
        if (dataObj) {
          const versionIds = Object.keys(dataObj).reverse();
          const panes = versionIds.map((id, versionIndex) => {
            const version = dataObj[id];
            const oldVersion =
              versionIndex + 1 >= versionIds.length
                ? version
                : dataObj[versionIds[versionIndex + 1]];
            if (version) {
              const oldSql =
                oldVersion &&
                oldVersion.translation &&
                oldVersion.translation.sql
                  ? sqlFormatter.format(oldVersion.translation.sql)
                  : "";
              const newSql =
                version && version.translation && version.translation.sql
                  ? sqlFormatter.format(version.translation.sql)
                  : "";
              return {
                menuItem: (
                  <Menu.Item key={`message${versionIndex}`}>
                    <div>
                      <Label>v{versionIds.length - versionIndex}</Label>
                      <span> {timeFromNow(version.audit.createdAt)}</span>
                    </div>
                    <span> {version.audit.createdBy.name}</span>
                  </Menu.Item>
                ),
                render: () => (
                  <Tab.Pane>
                    <ReactDiffViewer
                      oldValue={oldSql}
                      newValue={newSql}
                      splitView={true}
                      compareMethod={DiffMethod.WORDS}
                    />
                  </Tab.Pane>
                ),
              };
            } else {
              return {};
            }
          });
          this.setState({ panes });
        }
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/CodeDiff/VersionHistoryModal.tsx